/* eslint-disable no-unused-vars */
import { DateRange } from 'components';

export const CampaignReportsCalendar = ({ dateRangeName$, dateFrom$, dateTo$ }) => {
  function updateRangeName(rangeName) {
    dateRangeName$.value = rangeName;
  }

  function updateTimeRange(fromDate, toDate) {
    dateFrom$.value = fromDate;
    dateTo$.value = toDate;
  }

  return (
    <DateRange
      dateFrom={dateFrom$.value}
      dateTo={dateTo$.value}
      dateRangeName={dateRangeName$.value}
      onUpdateRangeName={updateRangeName}
      onUpdateTimeRange={updateTimeRange}
    />
  );
};
